import { atom } from 'recoil';
import { ITimezoneState, TIMEZONE_OPTIONS } from './types';
import { 
	getDefaultTimezoneState, 
	parseStoredTimezone 
} from './utils';
import { TIMEZONE_STORAGE_KEY } from './constants';

/**
 * Gets initial timezone state from localStorage or defaults
 */
const getInitialTimezoneState = (): ITimezoneState => {
	const storedTimezone = localStorage.getItem(TIMEZONE_STORAGE_KEY);
	const parsedTimezone = parseStoredTimezone(storedTimezone);
	
	return parsedTimezone || getDefaultTimezoneState(TIMEZONE_OPTIONS);
};

export const timezoneState = atom<ITimezoneState>({
	key: 'user-timezone-state',
	default: getInitialTimezoneState(),
	effects: [
		// Sync with localStorage
		({ onSet }) => {
			// Save to localStorage when state changes
			onSet((newValue) => {
				try {
					localStorage.setItem(
						TIMEZONE_STORAGE_KEY, 
						JSON.stringify(newValue)
					);
				} catch (error) {
					// Failed to save timezone to localStorage
				}
			});
		},
	],
});
